import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { GetTobaccosInStock, GetTotalStats } from './thunks';
import { GetTobaccosInStockReducer, GetTotalStatsReducer, ResetDashboardStateReducer } from './reducers';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    ResetDashboardState: ResetDashboardStateReducer,
  },
  extraReducers: (builder) => {
    // GetTobaccosInStock
    addExtraReducer(builder, GetTobaccosInStock, GetTobaccosInStockReducer);
    // GetTotalStats
    addExtraReducer(builder, GetTotalStats, GetTotalStatsReducer);
  },
});

export default slice.reducer;
